import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RequestService from "../services/RequestService";
export default {
  props: {
    userId: Number | String,
    typeCall: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      requestService: new RequestService(),
      message: "",
      nameLocal: "",
      error: false,
      typeMessage: ["#name e #local", "#code, #place e #stand"]
    };
  },
  methods: {
    persist: function persist() {
      var _this = this;
      if (this.error || this.message.trim() === "") return;
      if (this.typeCall !== "local") {
        var payload = {
          clientId: this.$props.userId,
          callBy: this.$props.typeCall,
          message: this.message.toLowerCase()
        };
        this.$root.$emit("saving-message", true, payload);
        this.requestService.saveMessage(payload).then(function (data) {
          _this.$root.$emit("hide-dialog");
          _this.$root.$emit("saving-message", false, {
            error: false
          });
          _this.message = "";
        }).catch(function (err) {
          _this.$root.$emit("saving-message", false, {
            error: true
          });
          alert("Erro ao salvar menssagem");
        });
      } else {
        var _payload = {
          clientId: this.$props.userId,
          name: this.message
        };
        this.$root.$emit("saving-message", {
          condition: true,
          type: "placeName"
        }, _payload);
        this.requestService.savePlace(_payload).then(function (data) {
          _this.$root.$emit("hide-dialog");
          _this.$root.$emit("saving-message", false, {
            error: false
          });
          _this.message = "";
        }).catch(function (err) {
          _this.$root.$emit("saving-message", false, {
            error: true
          });
          alert("Erro ao salvar");
        });
      }
    },
    cancel: function cancel() {
      this.$root.$emit("hide-dialog", true);
      this.message = "";
    },
    validateMsg: function validateMsg() {
      if (this.typeCall === "name" && (this.message.toLowerCase().indexOf("#name") == -1 || this.message.toLowerCase().indexOf("#local") == -1)) {
        this.error = true;
      } else if (this.typeCall === "code" && (this.message.toLowerCase().indexOf("#code") == -1 || this.message.toLowerCase().indexOf("#stand") == -1 || this.message.toLowerCase().indexOf("#place") == -1)) {
        this.error = true;
      } else if (this.message.trim() === "") {
        this.error = true;
      } else {
        this.error = false;
      }
    }
  }
};